import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import {
  IAIImageModel,
  IAIImageProject,
  IAIImageStyle
} from 'store/types/aiImage'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import CopyIcon from 'assets/svgr-icons/Copy.svg'
import Tooltip from 'components/Tooltip'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

interface IImageDetailsContentProps {
  item: IAIImageProject
  aiImageModels: IAIImageModel[]
  aiImageStyles: IAIImageStyle[]
}

const ImageDetailsContent = ({
  item,
  aiImageModels,
  aiImageStyles
}: IImageDetailsContentProps) => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const MAX_PROMPT_DISPLAY_LENGTH = isMobile ? 150 : 440
  const TRUNCATED_SLICE_LENGTH = isMobile ? 150 : 460

  const displayPrompt =
    item.prompt.length > MAX_PROMPT_DISPLAY_LENGTH
      ? `${item.prompt.slice(0, TRUNCATED_SLICE_LENGTH)}...`
      : item.prompt

  const modelName =
    aiImageModels.find(model => model.code === item.model)?.name ?? item.model
  const styleName =
    item.styleName ||
    aiImageStyles.find(style => style.id === item.styleId)?.name ||
    '-'

  const handleCopyPrompt = () => {
    navigator.clipboard.writeText(item.prompt)
  }

  return (
    <Styled.Content>
      {item.prompt.length > 0 ? (
        <>
          <Styled.PromptHeader>
            <Text color="secondary" type="h4">
              {translate(T.PROMPT)}
            </Text>
            <Tooltip tooltipText={translate(T.COPY_PROMPT_TOOLTIP)}>
              <Styled.CopyButton onClick={handleCopyPrompt}>
                <CopyIcon />
              </Styled.CopyButton>
            </Tooltip>
          </Styled.PromptHeader>
          <Styled.PromptText type="h2" color="secondaryDark">
            {displayPrompt}
          </Styled.PromptText>
        </>
      ) : null}
      <Styled.MetaInfo>
        <Styled.MetaChip>
          <Text color="secondaryDark" type="h4">
            {modelName}
          </Text>
        </Styled.MetaChip>
        <Styled.MetaChip>
          <Text color="secondaryDark" type="h4">
            {item.aspectRatio}
          </Text>
        </Styled.MetaChip>
        <Styled.MetaChip>
          <Text color="secondaryDark" type="h4">
            {styleName}
          </Text>
        </Styled.MetaChip>
      </Styled.MetaInfo>
      <Styled.ReferenceImages>
        {item.refImages?.length > 0 ? (
          <>
            <Text color="secondary" type="h4">
              {translate(T.REFERENCE_IMAGES_LABEL)}
            </Text>
            <Styled.RefImages>
              {item.refImages?.map(url => (
                <Styled.RefImage key={url} src={url} alt="reference-image" />
              ))}
            </Styled.RefImages>
          </>
        ) : null}
      </Styled.ReferenceImages>
    </Styled.Content>
  )
}

export default ImageDetailsContent
